import axios from 'axios';
import {DocumentType} from "@/shared/model/enumerations/document-type.model";

const baseApiUrl = 'api/admin/upload';

export default class DocumentService {
    public upload(formData: FormData, documentType: DocumentType): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .post(`${baseApiUrl}?type=${documentType}`, formData)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}
